// src/api/services/reservationService.js
import apiClient, { api } from "../httpClient";
import { API_ENDPOINTS } from "../config";

/**
 * Create reservation in our DB (OTA step 1)
 * @param {Object} payload - reservation/create payload
 * @returns {Promise<{status: string, reservation_number: string, timestamp?: string}>}
 */
export const createReservation = async (payload) => {
  const res = await api.post(API_ENDPOINTS.RESERVATION_CREATE, payload);

  // normalize + validate minimal contract
  const reservationNumber = res?.reservation_number;
  const status = res?.status;

  if (status !== "SUCCESS" || !reservationNumber) {
    const msg =
      res?.message ||
      "Reservation create failed. Invalid response from server.";
    const err = new Error(msg);
    err.payload = res;
    throw err;
  }

  return res;
};

/**
 * Process reservation (vendor confirmation) after payment success
 * @param {Object} payload
 * @param {string} payload.reservationNumber
 * @param {string} payload.sessionId
 * @returns {Promise<Object>}
 */
export const processReservation = async ({
  reservationNumber,
  sessionId,
  stripeToken,
  paymentIntentId,
  authenticationTransactionId,
  customer 
}) => {
  if (!reservationNumber || (!sessionId  && !paymentIntentId)) {
    // ← ADD paymentIntentId check
    throw new Error("Missing reservationNumber or payment token");
  }

  const body = { reservation_number: reservationNumber };

  if (paymentIntentId) {
    /* Stripe — send paymentIntentId, Java confirms on backend */
    body.payment_intent_id = paymentIntentId;
    body.customer = customer // ← ADD (confirm exact key name with backend dev)
  } else {
    /* Fiserv — send session_id as before */
    body.session_id = sessionId;
    if (authenticationTransactionId) {
      body.authentication_transaction_id = authenticationTransactionId; 
    }
  }

  const res = await apiClient.post(API_ENDPOINTS.RESERVATION_PROCESS, body);

  return res;
};

export const getReservation = async ({ emailId, reservationNumber }) => {
  if (!emailId || !reservationNumber) {
    throw new Error("Missing emailId or reservationNumber");
  }

  const res = await apiClient.post(API_ENDPOINTS.RESERVATION_GET, {
    email_id: emailId,
    reservation_number: reservationNumber,
  });

  return res;
};

export const generateCancelCode = async ({ emailId, reservationNumber }) => {
  return await apiClient.post(API_ENDPOINTS.CANCEL_CODE_GENERATE, {
    email: emailId,
    reservation_number: reservationNumber,
  });
};

export const cancelReservation = async ({ emailId, reservationNumber, otpCode, reason }) => {
  return await apiClient.post(API_ENDPOINTS.CANCEL_RESERVATION, {
    email: emailId,
    reservation_number: reservationNumber,
    code: otpCode, // Backend expected key for OTP
    reason: reason,
  });
};
